import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useUpdateSociogramTeacherAccess = (options = {}) => {
  const mutation = useApiMutation(
    'schools',
    ({ enrollmentId }) =>
      `/current-organization/current-term/sociogram-teachers/${enrollmentId}/access`,
    'patch',
    options,
    { authenticated: true, version: 5 }
  )

  return {
    isUpdatingAccess: mutation.isPending,
    errorUpdatingAccess: mutation.error ?? null,
    updateTeacherAccess: ({ enrollmentId, accessState, eventId }) =>
      mutation.mutateAsync({
        enrollmentId,
        data: { accessState, eventId }
      })
  }
}
